import { handleError, handleLongText, toTitleCase } from 'config/libraries';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';

export const SideMenu = ({page_type}) => {
    // page_type = berita, kategori, galeri gambar, galeri video

    const [DataResponse, setDataResponse] = useState([]);
    const [DataResponseKategori, setDataResponseKategori] = useState([]);
    useEffect(() => {
        const axios = require('axios');
        axios.get(process.env.REACT_APP_SERVER_BASE_URL + '/'+ page_type +'?per_page=4&page=1&sort_by=total_hit&sort_type=asc').then(function (response) {
            setDataResponse(response.data.data.data);
        }).catch(function (error) {
            handleError(error)
        })

        axios.get(process.env.REACT_APP_SERVER_BASE_URL + '/kategori-' + page_type).then(function (response) {
            setDataResponseKategori(response.data.data);
        }).catch(function (error) {
            handleError(error)
        })
        return () => {
            setDataResponse(null);
        };
    }, []);

    return (
        <div className="jl_sidebar_w">
            <div id="sprasa_recent_post_text_widget-9" className="widget post_list_widget">
                <div className="widget_jl_wrapper">
                    <div className="ettitle">
                        <div className="widget-title">
                            <h2 className="jl_title_c">{ toTitleCase(page_type) } Terpopuler</h2>
                        </div>
                    </div>
                    <div className="bt_post_widget">
                        {
                            DataResponse && DataResponse.map((item, index) => {
                                return (
                                    <div key={index} className="jl_m_right jl_sm_list jl_ml jl_clear_at">
                                        <div className="jl_m_right_w">
                                            <div className="jl_m_right_img jl_radus_e">
                                                {
                                                    (page_type === 'berita') ?
                                                        <Link to={'/berita/' + item.slug_berita}>
                                                            <img width={100} height={100} src={process.env.REACT_APP_SERVER_IMAGE_URL + item.gambar_berita} className="attachment-sprasa_small_feature size-sprasa_small_feature wp-post-image fixed-image-100" alt="" loading="lazy" />
                                                        </Link> :
                                                    (page_type === 'artikel') ?
                                                        <Link to={'/artikel/' + item.slug_artikel}>
                                                            <img width={100} height={100} src={process.env.REACT_APP_SERVER_IMAGE_URL + item.gambar_artikel} className="attachment-sprasa_small_feature size-sprasa_small_feature wp-post-image fixed-image-100" alt="" loading="lazy" />
                                                        </Link> : ''
                                                }
                                                
                                            </div>
                                            <div className="jl_m_right_content">
                                                <h2 className="entry-title">
                                                    {
                                                        (page_type === 'berita') ?
                                                            <Link to={'/berita/' + item.slug_berita}>
                                                                {handleLongText(item.judul_berita, 50)}
                                                            </Link> :
                                                        (page_type === 'artikel') ?
                                                            <Link to={'/artikel/' + item.slug_artikel}>
                                                                {handleLongText(item.judul_artikel, 50)}
                                                            </Link> :
                                                        (page_type === 'galeri_foto') ?
                                                            <Link to={'/berita/' + item.slug_berita}>
                                                                {handleLongText(item.judul_berita, 50)}
                                                            </Link> :
                                                        (page_type === 'video') ?
                                                            <Link to={'/berita/' + item.slug_berita}>
                                                                {handleLongText(item.judul_berita, 50)}
                                                            </Link> : ''
                                                    }
                                                </h2>
                                                <span className="jl_post_meta">
                                                    <span className="jl_author_img_w">
                                                        <i className="jli-user" />
                                                        {
                                                            (page_type === 'berita') ?
                                                                <Link to={'/berita/' + item.slug_berita} title={item.nama_kategori_berita} rel="author">
                                                                    {item.nama_kategori_berita}
                                                                </Link> :
                                                            (page_type === 'artikel') ?
                                                                <Link to={'/artikel/' + item.slug_artikel} title={item.nama_kategori_artikel} rel="author">
                                                                    {item.nama_kategori_artikel}
                                                                </Link> :
                                                            (page_type === 'galeri_foto') ?
                                                                <Link to={'/berita/' + item.slug_berita} title={item.nama_kategori_berita} rel="author">
                                                                    {item.nama_kategori_berita}
                                                                </Link> :
                                                            (page_type === 'video') ?
                                                                <Link to={'/berita/' + item.slug_berita} title={item.nama_kategori_berita} rel="author">
                                                                    {item.nama_kategori_berita}
                                                                </Link> : ''
                                                        }
                                                        
                                                    </span>
                                                    <span className="post-date">
                                                        <i className="jli-pen" />{item.created_at}
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>

            {
                (page_type === 'berita' || page_type === 'artikel') ?
                <div id="sprasa_ads300x250_widget-2" className="widget jellywp_ads300x250_widget">
                    <div className="widget_jl_wrapper ads_widget_container">
                        <div className="widget-title">
                            <h2 className="jl_title_c">Kategori { toTitleCase(page_type) }</h2>
                        </div>
                        <div className="tag-cat">
                            <ul className="single_post_tag_layout">
                            {
                                (page_type === 'berita') ?
                                    <li>
                                        {
                                            DataResponseKategori && DataResponseKategori.map((item, index) => {
                                                return (
                                                    <Link key={index} to={item.slug_kategori_berita} rel={item.nama_kategori_berita}>{item.nama_kategori_berita}</Link>
                                                )
                                            })
                                        }
                                    </li> :
                                (page_type === 'artikel') ?
                                    <li>
                                        {
                                            DataResponseKategori && DataResponseKategori.map((item, index) => {
                                                return (
                                                    <Link key={index} to={item.slug_kategori_artikel} rel={item.nama_kategori_artikel}>{item.nama_kategori_artikel}</Link>
                                                )
                                            })
                                        }
                                    </li> : ''
                            }
                               
                            </ul>
                        </div>
                    </div>
                </div> : ''
            }
            
        </div>
    )
};